
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcResistor as ObcResistorElement} from '@oicl/openbridge-webcomponents/dist/automation/resistor/resistor.js';
 
 
 

 
 export const ObcResistor = createComponent({
   react: React,
   tagName: 'obc-resistor',
   elementClass: ObcResistorElement,
   events: {
     
   }
  });
 
 